import React, { useEffect } from 'react';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/agroLayoutReducer';
import DiscreteTabs from 'components/DesignSystem/Tabs/DiscreteTabs';
import { Outlet } from 'react-router-dom';

export default function CultureIndex() {
  useEffect(() => {
    store.dispatch(setCurrentTab('culture-index'));
  }, []);

  return (
    <div className="px-0 pt-0 px-lg-5 pt-lg-4">
      <DiscreteTabs type="round" activeKey="./">
        <DiscreteTabs.Tab
          path="/agro/culture-index/area"
          title="Índice por área"
        />
        <DiscreteTabs.Tab
          path="/agro/culture-index/location"
          title="Índice por local"
        />
      </DiscreteTabs>
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
}
